__turbopack_context__.v({
  "aurora": "jTTlfG_aurora",
  "auroraWrap": "jTTlfG_auroraWrap",
  "fromLeft": "jTTlfG_fromLeft",
  "fromRight": "jTTlfG_fromRight",
  "grain": "jTTlfG_grain",
  "hero": "jTTlfG_hero",
  "inner": "jTTlfG_inner",
  "inviteDriftSize": "jTTlfG_inviteDriftSize",
  "inviteDriftTilt": "jTTlfG_inviteDriftTilt",
  "inviteDriftX": "jTTlfG_inviteDriftX",
  "inviteDriftY": "jTTlfG_inviteDriftY",
  "inviteOrbGone": "jTTlfG_inviteOrbGone",
  "inviteOrbOpen": "jTTlfG_inviteOrbOpen",
  "inviteTextIn": "jTTlfG_inviteTextIn",
  "mirror": "jTTlfG_mirror",
  "name": "jTTlfG_name",
  "play": "jTTlfG_play",
  "scrim": "jTTlfG_scrim",
});
